<div class="main">
  <h2>Punzados en ICP</h2>

  <div style="min-height: 50vh; width: 100vw" *ngIf="isLoading">
    <div class="loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="container" *ngIf="!isLoading">
    <table mat-table [dataSource]="perforationsIcp" class="perforations-icp">
      <ng-container matColumnDef="segmentStatus">
        <mat-header-cell *matHeaderCellDef> Estado Segmento </mat-header-cell>
        <mat-cell *matCellDef="let perf">
          {{ perf.segmentStatus }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="top">
        <mat-header-cell *matHeaderCellDef> Tope [m] </mat-header-cell>
        <mat-cell *matCellDef="let perf">
          {{ perf.top | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="base">
        <mat-header-cell *matHeaderCellDef> Base [m] </mat-header-cell>
        <mat-cell *matCellDef="let perf">
          {{ perf.base | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef> Fecha Int </mat-header-cell>
        <mat-cell *matCellDef="let perf">
          {{ perf.startDate | date : "dd/MM/yyyy" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="rePerforation">
        <mat-header-cell *matHeaderCellDef> Repunzado </mat-header-cell>
        <mat-cell *matCellDef="let perf">
          {{ perf.rePerforation == "S" ? "Si" : "No" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="4">
          <div class="footer">
            <div class="footer-no-data">No se encontraron datos.</div>
            <div class="footer-no-data-origin">
              De existir datos en el sistema de origen, podrás visualizarlos
              acá.
            </div>
          </div>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      <mat-footer-row
        *matFooterRowDef="['noData']"
        [ngClass]="{ 'hide-footer': hideFooter }"
      ></mat-footer-row>
    </table>
  </div>
</div>
